import script from "./BotsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsMenu.vue?vue&type=script&setup=true&lang=js"

import "./BotsMenu.vue?vue&type=style&index=0&id=4ea8786e&lang=css"

const __exports__ = script;

export default __exports__